import { supabase, publicSupabase } from '@/lib/supabase';
async function result(request) {
  const { data, error } = await request;
  if (error) throw new Error(error.message);
  return data;
}
export const manageSupplierReturn = (lineId, action = 'get') => result(supabase.rpc('mfg_supplier_return_manage', { p_line: lineId, p_action: action }));
export const readSupplierReturn = (token) => result(publicSupabase.rpc('mfg_supplier_return_read', { p_token: token }));
export const submitSupplierReturn = (token, version, quantities, notes) => result(publicSupabase.rpc('mfg_supplier_return_submit', { p_token: token, p_version: version, p_quantities: quantities, p_notes: notes }));
export function supplierReturnUrl(token) {
  const url = new URL(import.meta.env.VITE_SUPPLIER_RETURN_BASE_URL || window.location.href);
  url.search = '';
  url.hash = `/devolucion/${token}`;
  return url.href;
}

export const fetchPendingSupplierReturns = (suborderId) => result(supabase.rpc('mfg_supplier_return_pending', { p_suborder: suborderId }));

export const fetchSupplierReturnStatuses = (suborderId) => result(supabase.rpc('mfg_supplier_return_status', { p_suborder: suborderId }));
